import state from './moduleBillingDocState.js'
import mutations from './moduleBillingDocMutation.js'
import actions from './moduleBillingDocActions.js'
import getters from './moduleBillingDocGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

